import useApi from "./useApiRequest";
import { useMutation } from "react-query";

export const GetContenedores = ()  => {
    const api = useApi();

    const mutate = async () => {
        const data  = await api.get(`/contenedores`);
        return data.data;
    };

    const mutation = useMutation(mutate);

    return {
        getContenedoresMutation: mutation.mutate,
    };
}